document.addEventListener('DOMContentLoaded', () => {
  // ==============================
  // Accessibility: Drawer focus handling
  // ==============================
  const drawer = document.getElementById('NavDrawer');
  const openButton = document.querySelector('.js-drawer-open-nav'); // hamburger button
  const closeButtons = drawer.querySelectorAll('.js-drawer-close, .close_navigation'); // all close triggers
  let lastFocusedElement = null;

  // Open drawer
  if (openButton) {
    openButton.addEventListener('click', () => {
      lastFocusedElement = openButton;
      drawer.classList.add('drawer--is-open');

      // Move focus to first focusable inside drawer
      const focusable = drawer.querySelectorAll(
        'button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (focusable.length) {
        focusable[0].focus();
      }
    });
  }

  // Close drawer
  function closeDrawer() {
    setTimeout(() => {
      drawer.classList.remove('drawer--is-open', 'is-transitioning');

      // Always restore focus to hamburger button
      if (openButton) {
        openButton.focus();
      }
    }, 500);
  }

  closeButtons.forEach((btn) => {
    btn.addEventListener('click', closeDrawer);
  });

  // Close with ESC key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('drawer--is-open')) {
      closeDrawer();
    }
  });

  // ==============================
  // Your existing mobile navigation logic
  // ==============================
  const menuItems = document.querySelectorAll('.mobile-nav li a, .mobile-nav li button');
  const backButtons = document.querySelectorAll('.back-button');
  const recall_container = document.querySelector('.drawer__scrollable .recall_container');

  menuItems.forEach((item) => {
    item.addEventListener('click', (event) => {
      const check_mobile_url = item.getAttribute('href');
      if (check_mobile_url === '#') {
        event.preventDefault();
        recall_container.classList.add('hidden');
        item.parentNode.classList.add('active');
      } else if (event.currentTarget.type === 'button') {
        item.parentNode.classList.add('active');
        recall_container.classList.add('hidden');
      }
    });
  });

  backButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const currentSubNav = button.closest('li.active');
      if (currentSubNav) {
        currentSubNav.classList.remove('active');
        if(!currentSubNav.classList.contains('mobile-submenu-item')) {
          recall_container.classList.remove('hidden');
        }
      }
    });
  });
});
